import Auth from './auth.js';

/** type {import('@nuxt/types').Plugin} */
export default async function(context, inject) {
    const auth = new Auth(context, {"excludeRoutes":["family-accept-invite-validationSessionId"],"extraAuthParams":function ({ app }) {
      const { locale } = app.i18n;
      return { lang: locale };
    },"endpoints":{"accessToken":"https:\u002F\u002Flogin.tidal.com\u002Foauth2\u002Ftoken","authorization":"https:\u002F\u002Flogin.tidal.com\u002Fauthorize","login":"\u002Flogin","logout":"\u002Flogout","oauthServerOrigin":"http:\u002F\u002Fauth.int.tidalhi.fi:8080","signup":"http:\u002F\u002Fuserwebapi.int.tidalhi.fi"},"defaultCookieOptions":{"secure":true,"path":"\u002F"},"storageKeys":{"authState":"auth.state","transientData":"auth.transient_data","returnUrl":"auth.return_url"},"vuex":{"namespace":"auth"},"env":"prod","clientSecret":"b9p5BZAelxHs5bz3ZHyT841gKQdSDZBywjbcvoA2TzI=","oauthParams":{"client_id":"bzgWRijM53od7Cdn","redirect_uri":"https:\u002F\u002Faccount.tidal.com\u002Flogin\u002Ftidal\u002Freturn","response_type":"code"},"redirectBase":"https:\u002F\u002Faccount.tidal.com","webSessionGetter":function webSessionGetter() {
  if (!session) {
    session = (0, _webSession.webSession)({
      serviceKey: _package.default.name,
      domain: process.env.TIDAL_DOMAIN || '',
      env: _constants.default.ENV });
  }
  return session;
}});
    await auth.init();

    inject('tidalAuth', auth);
}
